import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import Index from '@/pages/index'
import skillList from '@/pages/skillList'
import lifelList from '@/pages/lifeList'
import momentsList from '@/pages/goodMoments'
import detail from '@/pages/detail'

export default new Router({
    mode:'history',
    routes:[
        {
            path:'/',
            name:'index',
            component:Index
        },
		{
			path:'/skill',
			name:'skill',
			component:skillList
		},
		{
			path:'/life',
			name:'life',
			component:lifelList
		},
		{
			path:'/moments',
			name:'moments',
			component:momentsList
		},
		{
			path:'/detail',
			name:'detail',
			component:detail
		}
    ]
})